import Axios from "axios";
import Apis from "../../config/Apis";
import {
  hideLoading,
  showLoading,
  showAlert,
  UpdateTypes,
} from "../Actions/GeneralActions";
// import { headers } from '../../Utils';
import {
  createPlanningTemplate,
  createQuestion,
  createSection,
  createSubSection,
  deleteQuestion,
  deleteSection,
  getPlanningTemplate,
  getPublicTemplate,
  getQuestion,
  getSection,
  getSubSection,
  getVendorEvents,
  getViewResult,
  updateQuestion,
  updateSection,
} from "../Actions/PlanningTemplatesAction";
import { getEventDetail } from "../Actions/EventAction";
import { headers } from "../../utills";
import { EventPlanningMiddleware } from "./EventPlanningMiddleware";

export const PlanningTemplatesMiddleware = {
  getVendorEvents: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.post(
            Apis.getVendorEvent,
            {},
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(getVendorEvents(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Vendor Events",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  // getPlanningTemplates: () => {
  //   return dispatch => {
  //     dispatch(showLoading())
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         const data = await Axios.post(Apis.getPlanningTemplate, {}, await headers.config())
  //         if (data?.status == 200) {
  //           dispatch(hideLoading())
  //           resolve(true)
  //           dispatch(getPlanningTemplate(data?.data?.data))
  //         }
  //       } catch (error) {
  //         dispatch(hideLoading())
  //         reject(error);
  //         dispatch(
  //           showAlert({
  //             title: 'Get Planning Templates',
  //             message: error?.response?.data?.message,
  //             type: 'Error',
  //             status: error?.response?.status,
  //           }),
  //         );
  //       }
  //     })
  //   }
  // },
  getPlanningTemplates: ({ event_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (event_id) formdata.append("event_id", event_id);
          const data = await Axios.post(
            Apis.getPlanningTemplate,
            event_id ? formdata : {},
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(data?.data?.data);
            dispatch(getPlanningTemplate(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "Get Planning Templates",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createPlanningTemplates: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("title", eventData?.title);
          const data = await Axios.post(
            Apis.createPlanningTemplate,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(createPlanningTemplate(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Create Planning Templates",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Create Planning Templates",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getSections: (tempData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("planningtemplate_id", tempData?.id);
          const data = await Axios.post(
            Apis.getSection,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(getSection(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Section",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
  getSubSections: (tempData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (tempData?.event_id)
            formdata.append('event_id', tempData?.event_id)
          formdata.append("parent_id", tempData?.id);
          if (tempData?.shared_planning_template_id) {
            formdata.append("shared_planning_template_id", tempData?.shared_planning_template_id);
          }
          const data = await Axios.post(
            Apis.getSubSections,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(getSubSection(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Section",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createSection: (sectionData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("planningtemplate_id", sectionData?.id);
          formdata.append("name", sectionData?.name);
          formdata.append("description", sectionData?.Description);
          formdata.append("visibility", sectionData?.visibility);
          const data = await Axios.post(
            Apis.createSection,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(createSection(data?.data?.data));
            resolve(data?.data?.data);
            dispatch(
              showAlert({
                title: "Create Section",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  createSubSection: (sectionData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("parent_id", sectionData?.id);
          formdata.append("planningtemplate_id", sectionData?.plainningid);
          formdata.append("name", sectionData?.name);
          formdata.append("description", sectionData?.Description);
          formdata.append("visibility", sectionData?.visibility);
          formdata.append('is_music', sectionData?.isMusic ? 1 : 0);
          if (sectionData?.musicLimit)
            formdata.append('music_limit', sectionData?.musicLimit);
          const data = await Axios.post(
            Apis.createSection,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            console.log("dataaaaqaa", data?.data?.data);
            dispatch(createSubSection(data?.data?.data));
            resolve(data?.data?.data);
            dispatch(
              showAlert({
                title: "Create Section",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  sortedSections: (sections) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          for (const [i, element] of sections.entries()) {
            formdata.append(`sections[${i}][id]`, element?.id);
            formdata.append(`sections[${i}][sort_no]`, i);
          }
          const data = await Axios.post(
            Apis.sortSections,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(
              showAlert({
                title: "sortedSections",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "sortedSections",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  editSection: (sectionData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("planningtemplate_id", sectionData?.template_id);
          formdata.append("id", sectionData?.sectionID);
          formdata.append("name", sectionData?.name);
          formdata.append("description", sectionData?.Description);
          formdata.append("visibility", sectionData?.visibility);
          formdata.append('is_music', sectionData?.isMusic ? 1 : 0);
          if (sectionData?.musicLimit)
            formdata.append('music_limit', sectionData?.musicLimit);
          const data = await Axios.post(
            Apis.updateSection,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(updateSection(data?.data?.data));
            resolve(data?.data?.data);
            dispatch(
              showAlert({
                title: "Update Section",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
          else {
            dispatch(
              showAlert({
                title: "Update Section",
                message: data?.data?.message,
                type: "Error",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Update Section",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deleteSection: (sectionData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", sectionData?.id);
          const data = await Axios.post(
            Apis.deleteSection,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(deleteSection(sectionData?.id));
            resolve(sectionData);
            dispatch(
              showAlert({
                title: "Delete Section",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Delete Section",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  unlinkTemplateSection: (sectionData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("section_id", sectionData?.section_id);
          formdata.append(
            "planning_template_id",
            sectionData?.planningtemplate_id
          );
          if (sectionData?.shared_planning_template_id) {
            formdata.append("shared_planning_template_id", sectionData?.shared_planning_template_id);
          }
          const data = await Axios.post(
            Apis.unlinkTemplateSection,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(deleteSection(sectionData?.section_id));
            resolve(true);
            dispatch(
              showAlert({
                title: "unlinkTemplateSection",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "unlinkTemplateSection",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deletePlanningTemplate: ({ id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", id);
          const data = await Axios.post(
            Apis.deletePlanningTemplate,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "deletePlanningTemplate",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "deletePlanningTemplate",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getQuestions: (secData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("templatesection_id", secData);
          const data = await Axios.post(
            Apis.getQuestion,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getQuestion(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "Get Section",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createQuestion: (questionData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("templatesection_id", questionData?.id);
          formdata.append("question", questionData?.question);
          formdata.append("type", questionData?.type);
          if (
            questionData?.type == "multiple_option" ||
            questionData?.type == "set_option"
          ) {
            for (const [i, element] of questionData?.optionArray?.entries()) {
              formdata.append(`options[${i}]`, element?.name);
            }
          }
          const data = await Axios.post(
            Apis.createQuestion,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(createQuestion(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Create Question",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  editQuestion: (questionData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", questionData?.questionID);
          formdata.append("templatesection_id", questionData?.id);
          formdata.append("question", questionData?.question);
          formdata.append("type", questionData?.type);
          if (
            questionData?.type == "multiple_option" ||
            questionData?.type == "set_option"
          ) {
            for (const [i, element] of questionData?.optionArray?.entries()) {
              formdata.append(`options[${i}]`, element?.name);
            }
          }
          const data = await Axios.post(
            Apis.updateQuestion,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(updateQuestion(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Update Question",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deleteQuestion: (questionData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", questionData?.id);
          const data = await Axios.post(
            Apis.deleteQuestion,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(deleteQuestion(questionData?.id));
            resolve(true);
            dispatch(
              showAlert({
                title: "Delete Question",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Delete Question",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getPublicTemplates: ({ event_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (event_id) formdata.append("event_id", event_id);
          const data = await Axios.post(
            Apis.getPlanningTemplatePublic,
            event_id ? formdata : {},
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getPublicTemplate(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "Get Public Templates",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
  associatePlanningTemplate: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", eventData?.event_id);
          formdata.append(
            "planning_template_id",
            eventData?.planning_template_id
          );
          const data = await Axios.post(
            Apis.associatePlanningTemplate,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventDetail(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "associatePlanningTemplate",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "associatePlanningTemplate",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  deAssociatePlanningTemplate: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", eventData?.event_id);
          formdata.append(
            "planning_template_id",
            eventData?.planning_template_id
          );
          const data = await Axios.post(
            Apis.deAssociatePlanningTemplate,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "deAssociatePlanningTemplate",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "deAssociatePlanningTemplate",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  addPublicTemplates: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", eventData?.event_id);
          formdata.append("planningtemplate_id", eventData?.temp_id);
          if (eventData?.shared_planning_template_id)
            formdata.append(
              "shared_planning_template_id",
              eventData?.shared_planning_template_id
            );
          const data = await Axios.post(
            Apis.addToMyPlanning,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "Add To MY Templates",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Add To MY Templates",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  saveTemplates: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", eventData?.event_id);
          const data = await Axios.post(
            Apis.saveTemplate,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventDetail(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Save Templates",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Save Templates",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  shareTemplate: ({ id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("planningtemplate_id", id);
          const data = await Axios.post(
            Apis.shareTemplateWithClient,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(showAlert(data?.data?.data));
            dispatch(
              showAlert({
                title: "shareTemplate",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "shareTemplate",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getViewResult: (tempData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", tempData?.event_id);
          formdata.append("parent_id", tempData?.parent_id);
          formdata.append("planningtemplate_id", tempData?.temp_id);
          if (tempData?.shared_planning_template_id) {
            formdata.append("shared_planning_template_id", tempData?.shared_planning_template_id);
          }
          const data = await Axios.post(
            Apis.viewResult,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            dispatch(getViewResult(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "Get View Result",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  generatePdf: ({ event_id, sections, title, parent_id, temp_id, shared_planning_template_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", event_id);
          formdata.append("parent_id", parent_id);
          formdata.append("temp_id", temp_id);
          for (const [i, element] of sections.entries()) {
            formdata.append(`question_ids[${i}]`, element?.id);
          }
          if (shared_planning_template_id) {
            formdata.append("shared_planning_template_id", shared_planning_template_id);
          }
          const data = await Axios.post(
            Apis.downloadSectionPdf,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            let file = {
              title: title,
              attachment: data?.data?.data?.url,
            };
            // dispatch(EventPlanningMiddleware.DownloadAttachment({ file }));
            dispatch(
              showAlert({
                title: "generatePdf",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
            resolve(file);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "generatePdf",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
